import React from "react";

import Layout from "../components/Layout";

export default function Blog() {
  
  return (
    <Layout>

      <section className="relative">
        <div className="container mx-auto px-6 py-16 md:py-24 text-center">
          <h1 className="mt-1 text-4xl md:text-6xl font-bold tracking-tight leading-tight">
            The P3 Blog
          </h1>
        </div>
      </section>

    </Layout>
  );
}  